import React, { useState, useEffect } from "react";
import axios from "axios";
import "../css/vehicle.css";
import useAuthRedirect from "../hooks/useAuthRedirect";
import InventoryNav from "../components/inventoryNav";
import IndentModal from "../components/indentModal";
import VehicleModal from "../components/indentVehicle";
import Time from "../components/time";
import Swal from "sweetalert2";
import { useNavigate, Link } from "react-router-dom";

import { hasPermission } from "../utils/permissionHelper";
import Access from "../components/access";
import { Eye, EyeOff } from "lucide-react";


const AddStn = () => {
  useAuthRedirect();
  const [showModal, setShowModal] = useState(false);
  const [showVehicleModal, setShowVehicleModal] = useState(false);
  const [selectedItems, setSelectedItems] = useState([]);
  const [currentVehicleIndex, setCurrentVehicleIndex] = useState(null);
  const branch = localStorage.getItem("branch");
  const userId = localStorage.getItem("username");
  const [indent, setIndent] = useState('');
  const [showLifeDetail, setShowLifeDetail] = useState(false);
  const [formData, setFormData] = useState({newPurNo: "", branches: "", deptAll: "", hod: "", reqBasis: "", ref: "", hm: "", remarks: "", dept: "" });
  const [stnNo, setStnNo] = useState('');
  const [dept, setDept] = useState([]);
  const [deptAll, setDeptAll] = useState([]);
  const [branches, setBranches] = useState([]);
  const navigate = useNavigate();

  const canEntry = hasPermission("STN Requisition", "entry");
  const canVehicle = hasPermission("Hire Vehicle Registration", "entry");


  

const showLoadingSwal = () => {
  Swal.fire({
    title: 'Fetching STN Details...',
    html: `
      <div style="width: 100%; background: #ddd; border-radius: 10px;">
        <div id="progressBar" style="height: 16px; width: 0%; background: linear-gradient(to right, #4facfe, #00f2fe); border-radius: 10px;"></div>
      </div>
      <p style="margin-top: 10px;" id="progressText">0%</p>
    `,
    showConfirmButton: false,
    allowOutsideClick: false,
    didOpen: () => {
      Swal.getPopup().querySelector('#progressBar').style.width = `0%`;
    }
  });
};

const updateSwalProgress = (percent) => {
  const progressBar = Swal.getPopup()?.querySelector('#progressBar');
  const progressText = Swal.getPopup()?.querySelector('#progressText');
  if (progressBar && progressText) {
    progressBar.style.width = `${percent}%`;
    progressText.textContent = `${percent}%`;
  }
};

// Main fetch handler with percentage
useEffect(() => {
  const fetchAll = async () => {
    showLoadingSwal();
    let progress = 0;
    const step = 25; 

    try {
      await fetchStnNoWrapped(); progress += step; updateSwalProgress(progress);
      await fetchDeptAllWrapped(); progress += step; updateSwalProgress(progress);
      await fetchBranchWrapped(); progress += step; updateSwalProgress(progress);
      if (branch) {
        await fetchDeptWrapped(); progress += step; updateSwalProgress(progress);
      } else {
        progress += step; updateSwalProgress(progress);
      }
      Swal.close();
    } catch (err) {
      Swal.close();
      Swal.fire({
        icon: 'error',
        title: 'Error!',
        text: 'One or more requests failed.',
      });
    }
  };

  {canEntry && (
  fetchAll()
  )}
}, [branch]);

// Wrapped versions of your fetchers
const fetchStnNoWrapped = async () => {
  const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stn_no");
  const purchaseNo = parseInt(response.data.priorPrNo, 10) || 0;
  setStnNo(purchaseNo.toString());
  setFormData(prev => ({ ...prev, newPurNo: purchaseNo.toString() }));
};

const fetchDeptAllWrapped = async () => {
  const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stn_department");
  setDeptAll(response.data.deptAll || []);
};

const fetchBranchWrapped = async () => {
  const response = await axios.get("https://rfs2.infraconsoft.net.in/api/stn_branch");
  setBranches(response.data.branch || []);
};

const fetchDeptWrapped = async () => {
  const response = await axios.get(`https://rfs2.infraconsoft.net.in/api/storeReq_department?branch_code=${branch}`);
  setDept(response.data.dept || []);
};

  const handleSelectItem = (item) => {
    setSelectedItems((prevItems) => [...prevItems, { ...item, vcode: "", vnumber: "", qty: "", duedate: "" }]);
  };

  const handleDeleteRow = (index) => {
    setSelectedItems((prevItems) => prevItems.filter((_, i) => i !== index));
  };

  const handleRowChange = (index, field, value) => {
    setSelectedItems((prevItems) =>
      prevItems.map((item, i) => (i === index ? { ...item, [field]: value } : item))
    );
  };

  const handleVehicleSelect = (vehicle_code, vehicle_number) => {
    if (!vehicle_code || !vehicle_number) {
      console.error("Vehicle selection error: Missing vehicle_code or vehicle_number");
      return;
    }
  
    console.log("Selected Vehicle:", vehicle_code, vehicle_number);
    
    if (currentVehicleIndex !== null) {
      setSelectedItems((prevItems) => {
        const updatedItems = prevItems.map((item, i) =>
          i === currentVehicleIndex ? { ...item, vcode: vehicle_code, vnumber: vehicle_number } : item
        );
        console.log("Updated Items:", updatedItems);
        return updatedItems;
      });
    }
  
    setCurrentVehicleIndex(null);
    setShowVehicleModal(false);
  };


  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };


  // Function to submit the form data
  const handleSubmit = async (e) => {
    e.preventDefault();

     if (!formData.deptAll.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select Department!',
        });
        return;
      }

if (!formData.branches || !formData.branches.trim()) {
  Swal.fire({
    icon: 'warning',
    title: 'Empty Field',
    text: 'Please Select To Branch!',
  });
  return;
}

      if (!formData.reqBasis.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select Your Requirement Basis!',
        });
        return;
      }

      if (!formData.dept.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select Issue Department!',
        });
        return;
      }

      if (!formData.hod.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Enter HOD!',
        });
        return;
      }

      if (!formData.hm.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Select Head Material!',
        });
        return;
      }

      if (!formData.ref.trim()) {
        Swal.fire({
          icon: 'warning',
          title: 'Empty Field',
          text: 'Please Enter Indent Ref No!',
        });
        return;
      }



    if (selectedItems.length === 0) {
  Swal.fire({
    icon: 'warning',
    title: 'No Items Selected',
    text: 'Please select at least one item before submitting.',
  });
  return;
}

for (let i = 0; i < selectedItems.length; i++) {
  const item = selectedItems[i];
  const index = i + 1;

  if (!item.qty || isNaN(item.qty) || Number(item.qty) <= 0) {
    Swal.fire({
      icon: 'warning',
      title: `Invalid Quantity (Row ${index})`,
      text: `Quantity should be a positive number.`,
    });
    return;
  }

  if (!item.duedate) {
    Swal.fire({
      icon: 'warning',
      title: `Missing Due Date (Row ${index})`,
      text: `Please enter a due date.`,
    });
    return;
  } else {
    const due = new Date(item.duedate);
    const today = new Date();
    today.setHours(0, 0, 0, 0);
    if (due < today) {
      Swal.fire({
        icon: 'warning',
        title: `Past Due Date (Row ${index})`,
        text: `Due date cannot be in the past.`,
      });
      return;
    }
  }

  // if (!item.life || isNaN(item.life) || Number(item.life) <= 0) {
  //   Swal.fire({
  //     icon: 'warning',
  //     title: `Invalid Life Value (Row ${index})`,
  //     text: `Life should be a positive number.`,
  //   });
  //   return;
  // }

  if (!item.purpose || item.purpose.trim().length < 3) {
    Swal.fire({
      icon: 'warning',
      title: `Purpose Too Short (Row ${index})`,
      text: `Purpose must be at least 3 characters long.`,
    });
    return;
  }

  if (!item.spec || item.spec.trim().length < 3) {
    Swal.fire({
      icon: 'warning',
      title: `Specification Too Short (Row ${index})`,
      text: `Specification must be at least 3 characters long.`,
    });
    return;
  }
}


    const payload = {
        branch: branch,
        stnNo: formData.newPurNo,
        toBranch: formData.branches,
        deptAll: formData.deptAll,
        hod: formData.hod,
        reqBasis: formData.reqBasis,
        ref: formData.ref,
        hm: formData.hm,
        remarks: formData.remarks,
        dept: formData.dept,
        items: selectedItems.map((item) => ({
            itemCode: item.itemmaster_code,
            itemName: item.itemmaster_name,
            uom: item.itemmaster_uom,
            price: item.itemmaster_price,
            partNo: item.itemmaster_drawingNumber,
            qty: item.qty,
            duedate: item.duedate,
            vcode: item.vcode,
            life: item.life,
            purpose: item.purpose,
            spec: item.spec,
            vname: item.vnumber,
        })),
    };

    try {
        Swal.fire({
            title: "Submitting...",
            text: "Please wait while we process your request.",
            allowOutsideClick: false,
            didOpen: () => {
                Swal.showLoading();
            },
        });
        const response = await axios.post(
            "https://rfs2.infraconsoft.net.in/api/stn_insert",
            payload
        );
        // alert("success");
        // console.log(response);
        Swal.fire("Success", "STN added successfully", "success");
        setSelectedItems([]);
        
        navigate('/inventory/stn_view');

    } catch (error) {
        console.error("Error submitting form:", error);
        Swal.fire("Error", "Submission failed. Please try again.", "error");
    }
};

 if (!canEntry) {
    return (
      <div id="admin-container">
        <InventoryNav />
        <div className="content-right" style={{ padding: 20 }}>
          <Access />
        </div>
      </div>
    );
  }
 

  return (
    <div id="admin-container">
      <InventoryNav />
      <div className="content-right">
        <section>
           <div className="back-div">
                    <h2 className="add-txt">Add STN Requisition</h2>
                    <Link to='/inventory/stn_view'><p className="back-button"><i className="fa-solid fa-backward"></i>Back</p></Link>
                    </div>
          <Time />
        </section>

       

        <div className="form-container">
          <form className="vehicle-form" onSubmit={handleSubmit}>

          <div className="form-row">
              <div className="form-group">
                <label>STN Req No :</label>
                <input type="text" name="newPurNo" value={formData.newPurNo} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Date :</label>
                <input type="date" name="endhrs" value={new Date().toISOString().split("T")[0]} readOnly />
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Department :</label>
                <select name="deptAll" value={formData.deptAll} onChange={handleChange}>
                  <option value="">-- Select Department --</option>
                  {deptAll.map((item, index) => (
                    <option key={index} value={item.departmentmaster_name}>
                      {item.departmentmaster_name}
                    </option>
                  ))}
                </select>
              </div>
              <div className="form-group">
                <label>To Branch :</label>
                <select name="branches" value={formData.branches} onChange={handleChange}>
                  <option value="">-- Select Branch --</option>
                  {branches.map((item, index) => (
                    <option key={index} value={item.branchMaster_code}>
                      {item.branchMaster_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>Requirment Basis :</label>
                <select name="reqBasis" value={formData.reqBasis} onChange={handleChange}>
                  <option value="">-- Select Basis --</option>
                  <option value="Emergency">Emergency</option> 
                  <option value="Urgent">Urgent</option> 
                  <option value="Ordinary">Ordinary</option>
                </select>
              </div>
              <div className="form-group">
                <label>Select Dept for Issue :</label>
                <select name="dept" value={formData.dept} onChange={handleChange}>
                  <option value="">-- Select Dept for issue --</option>
                  {dept.map((item, index) => (
                    <option key={index} value={item.departmentmaster_code}>
                      {item.departmentmaster_name}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="form-row">
              <div className="form-group">
                <label>H.O.D :</label>
                <input type="text" name="hod" value={formData.hod} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Head Meterial :</label>
                <input type="text" name="hm" value={formData.hm} onChange={handleChange} />
              </div>
            </div>


            <div className="form-row">
              <div className="form-group">
                <label>Remarks :</label>
                <input type="text" name="remarks" value={formData.remarks} onChange={handleChange} />
              </div>
              <div className="form-group">
                <label>Indent Ref No :</label>
                <input type="text" name="ref" value={formData.ref} onChange={handleChange} />
              </div>
            </div>



          <div className="flex_buttons">
          <button type="button" className="button button-add" onClick={() => setShowModal(true)}>Add Item</button>
        </div>
            <div className="content-table">
              <table>
                <thead>
                  <tr>
                    <th>S.No</th>
                    <th>Item Code</th>
                    <th>Item Name</th>
                    <th>Part No</th>
                    <th>UOM</th>
                    <th>Qty</th>
                    <th>Due Date</th>
                    <th>Specification</th>
                    <th>Purpose</th>
                    {canVehicle && (
                      <>
                    <th>Vehicle Code</th>
                    <th>Vehicle Number</th>
                    </>
                    )}
                     {showLifeDetail && (
                          <th style={{ textAlign: "center" }}>
                            Life Detail
                          </th>
                        )}
                    
                        <th>Remove</th>
                    
                        {/* Eye toggle column */}
                        <th>
                          <button
                            type="button"
                            onClick={() => setShowLifeDetail(!showLifeDetail)}
                            style={{
                              background: "none",
                              border: "none",
                              cursor: "pointer",
                            }}
                          >
                            {showLifeDetail ? <EyeOff size={18} /> : <Eye size={18} />}
                          </button>
                        </th>
                    
                  </tr>
                </thead>
                <tbody>
                  {selectedItems.length > 0 ? (
                    selectedItems.map((item, index) => (
                      <tr key={index}>
                        <td>{index + 1}</td>
                        <td>{item.itemmaster_code}</td>
                        <td>{item.itemmaster_name}</td>
                        <td>{item.itemmaster_drawingNumber}</td>
                        <td>{item.itemmaster_uom}</td>
                        <td><input type="number" value={item.qty} onChange={(e) => handleRowChange(index, "qty", e.target.value)} style={{"width": "50px"}}/></td>
                        <td><input type="date" value={item.duedate} onChange={(e) => handleRowChange(index, "duedate", e.target.value)} style={{"width": "50px"}}/></td>
                        <td><input type="text" value={item.spec} onChange={(e) => handleRowChange(index, "spec", e.target.value)} style={{"width": "50px"}}/></td>
                        <td><input type="text" value={item.purpose} onChange={(e) => handleRowChange(index, "purpose", e.target.value)} style={{"width": "50px"}}/></td>
                        {canVehicle && (
                      <>
                        <td><input type="text" value={item.vcode} readOnly onClick={() => {setCurrentVehicleIndex(index); setShowVehicleModal(true); }} placeholder="Select Vehicle" /></td>
                        <td><input type="text" value={item.vnumber} readOnly/></td> 
                        </>
                        )}
                         {showLifeDetail && (
 <td><input type="text" value={item.life} onChange={(e) => handleRowChange(index, "life", e.target.value)} style={{"width": "50px"}}/></td>
                )}
                       
                        <td className="del"><i className="fa-solid fa-trash-can" onClick={() => handleDeleteRow(index)}></i></td>
                      </tr>
                    ))
                  ) : (
                    <tr>
                      <td colSpan="9">No items added</td>
                    </tr>
                  )}
                </tbody>
              </table>
            </div>

            <div className="btn-cls">
              <button type="submit" className="submit-btn">
                Checkout
              </button>
            </div>

          </form>
        </div>
      </div>
      <IndentModal showModal={showModal} closeModal={() => setShowModal(false)} onSelectItem={handleSelectItem} branch={branch} />
      <VehicleModal showModal={showVehicleModal} closeModal={() => setShowVehicleModal(false)} onSelectVehicle={handleVehicleSelect} branch={branch} rowIndex={currentVehicleIndex} />

    </div>
  );
};

export default AddStn;